var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndritzLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "260px",
    height: "50px",
    viewBox: "0 0 260 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.04,49.64 L40.8,0.2 L24.12,0.08 L0,49.64 L42.6,49.64 L36.36,35.12 L24.84,35.12 L32.4,18.2 L46.44,49.64 L65.04,49.64 Z M152.28,17.72 C152.28,23.96 143.04,22.88 143.04,22.88 L143.04,13.64 C143.04,13.64 152.28,11.84 152.28,17.72 Z M165.48,22.4 C168.6,18.68 168.84,13.76 167.28,8.84 C165.48,3.8 159.84,0.8 154.68,0.32 L127.08,0.32 L127.08,17.12 C124.2,6.8 113.64,0.92 103.8,0.32 L83.4,0.32 L83.4,23.6 L68.88,0.2 L53.76,0.2 L53.76,19.88 L68.16,49.64 L68.64,49.64 L68.64,25.76 L82.68,49.64 L98.52,49.64 L98.52,14.24 C103.56,13.76 108.36,15.44 111.12,19.76 C112.56,22.04 113.16,25.88 111.96,28.4 C110.28,32.48 105.72,34.64 101.52,34.88 L101.52,49.64 C101.52,49.64 105.36,49.76 109.92,48.56 C117.36,46.88 125.04,39.2 126.96,31.52 L127.08,49.64 L142.92,49.64 L143.04,25.16 L156.84,49.64 L186.36,49.64 L186.36,17.48 L171,17.48 L171,41.6 L160.2,26.36 C161.52,25.76 164.52,23.48 165.48,22.4 Z M213.6,14.24 L219.6,0.2 L170.88,0.2 L170.88,14.24 L190.44,14.24 L190.44,49.76 L206.04,49.76 L206.04,14.24 L213.6,14.24 Z M253.2,34.88 L232.92,34.88 L246.48,0.2 L223.08,0.2 L217.08,14.24 L223.92,14.24 L207.96,49.76 L260.04,49.76 L253.2,34.88 Z",
    id: "Fill-18",
    fill: "#0075BE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndritzLogo);
export default __webpack_public_path__ + "static/media/andritzLogo.e9223732dd5d397b1cda0ed8a2b18b45.svg";
export { ForwardRef as ReactComponent };